<template>
    <main-content with_go_back_bar>
        <kt-panel v-if="!is_loading">
            <kt-panel-body>
                <kt-row>
                    <kt-col xs="12" sm="12">
                        <kt-form-group style="margin-top: 33px">
                            <kt-form-label for="gateway_title">
                                {{ $t('label.gateway_title') }} {{ ' :' }}
                            </kt-form-label>
                            <router-link :to="{name:'deposit_details',params:{hashid:request.gateway_id, gateway_source : this.gatewaySource}}">
                                {{ request.gateway_title }}
                            </router-link>
                        </kt-form-group>
                    </kt-col>
                    <kt-col v-for="(factor, index) in request.factor_numbers" :key="index" lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="factor_number">
                                {{ $t('deposit.deposit_id') +'\xa0'+ factor.bank_name}}
                            </kt-form-label>
                            <kt-form-control
                                id="factor_number"
                                disabled
                                name="factor_number"
                                v-model="factor.factor_number"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="payer_name">
                                {{ $t('deposit.payer_name') }}
                            </kt-form-label>
                            <kt-form-control
                                id="payer_name"
                                disabled
                                name="payer_name"
                                v-model="request.payer_name"
                                dir="rtl"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="payer_mobile">
                                {{ $t('deposit.payer_mobile') }}
                            </kt-form-label>
                            <kt-form-control
                                id="payer_mobile"
                                disabled
                                name="payer_mobile"
                                v-model="request.payer_mobile"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="created_at">
                                {{ $t('label.created_at') }}
                            </kt-form-label>
                            <kt-form-control
                                id="created_at"
                                disabled
                                name="created_at"
                                v-model="request.created_at"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <kt-form-label for="created_at">
                    {{ $t('deposit.payer_ibans') }}
                </kt-form-label>
                <kt-row  v-for="(payer_iban, index) in request.payer_ibans" :key="index"
                         v-bind="payer_iban">
                    <kt-col lg="6" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-control
                                disabled
                                name="payer_iban"
                                :value="payer_iban"
                                dir="ltr"
                            >
                            </kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
// import {depositService} from '@/common/api.service'
import mainContent from '@/components/main-content'
import toastr from "toastr";
import RequestFilter from "./filter";
import {depositPfService, depositStarshopService } from "@/common/api.service"

export default {

    components: {
        RequestFilter,
        mainContent,
    },
    data() {
        return {
            request: {},
            is_loading : true,
            depositPfService,
            depositStarshopService
        }
    },
    computed: {
        gatewaySource() {
            return this.$route.params.gateway_source;
        },
        apiService() {
            return this.$route.params.gateway_source === 'pf' ? this.depositPfService : this.depositStarshopService;
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
    },
    methods: {},
    mounted() {
        this.apiService.adminFetchRequest(this.$route.params.hashid).then(response => {
            this.request = response.data.data;
            this.is_loading = false
        });
    }
}
</script>